import { GridFooterController } from '../controller/GridFooterController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { SelectOption } from '../../../ui/gzSelect/types';

export class GridFooterWebComponent extends BaseWebComponentElement {
  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, 'grid-summary'];
  }

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GridFooterController,
    });
  }

  set pageSize(pageSize: number) {
    this.setAttribute('data-page-size', JSON.stringify(pageSize));
  }

  get pageSize(): number {
    const pageSize = this.getAttribute('data-page-size');
    return pageSize ? parseInt(pageSize, 10) : 50;
  }

  set hideGridRefresh(value: boolean) {
    if (value) {
      this.setAttribute('hideGridRefresh', '');
    } else {
      this.removeAttribute('hideGridRefresh');
    }
  }

  get hideGridRefresh(): boolean {
    return this.hasAttribute('hideGridRefresh');
  }

  set hasPagination(value: boolean) {
    if (value) {
      this.setAttribute('hasPagination', '');
    } else {
      this.removeAttribute('hasPagination');
    }
  }

  get hasPagination(): boolean {
    return this.hasAttribute('hasPagination');
  }

  set numSelectedItems(numSelectedItems: number) {
    this.setAttribute('numSelectedItems', String(numSelectedItems));
  }

  get numSelectedItems(): number {
    const numSelectedItems = this.getAttribute('numSelectedItems');
    return numSelectedItems ? parseInt(numSelectedItems, 10) : 0;
  }

  set numTotalItems(numTotalItems: number) {
    this.setAttribute('numTotalItems', String(numTotalItems));
  }

  get numTotalItems(): number {
    const numTotalItems = this.getAttribute('numTotalItems');
    return numTotalItems ? parseInt(numTotalItems, 10) : 0;
  }

  set numTotalPages(numTotalPages: number) {
    this.setAttribute('numTotalPages', String(numTotalPages));
  }

  get numTotalPages(): number {
    const numTotalPages = this.getAttribute('numTotalPages');
    return numTotalPages ? parseInt(numTotalPages, 10) : 0;
  }

  set pageNumber(pageNumber: number) {
    this.setAttribute('pageNumber', String(pageNumber));
  }

  get pageNumber(): number {
    const pageNumber = this.getAttribute('pageNumber');
    return pageNumber ? parseInt(pageNumber, 10) : 1;
  }

  set pageSizeOptions(value: Array<SelectOption>) {
    this.setAttribute('page-size-options', JSON.stringify(value));
  }

  get pageSizeOptions(): Array<SelectOption> {
    const value = this.getAttribute('page-size-options');
    return value ? JSON.parse(value) : [];
  }

  get gridSummary(): string {
    const value = this.getAttribute('grid-summary');
    return value ? value : '';
  }

  set gridSummary(value: string) {
    this.setAttribute('grid-summary', value);
  }
}
